



































import { Component, Vue, Prop } from 'vue-property-decorator';
import { CartItem } from '@/models/cart';
import store from '@/store';
import { getModule } from 'vuex-module-decorators';
import CartModule from '@/store/modules/cart-module';
import { currency } from '@/utils/filters';

const cartModule = getModule(CartModule, store);

@Component({
  filters: {
    currency,
  },
})
export default class DmqCartItem extends Vue {

  @Prop()
  private item!: CartItem;

  private remove() {
    cartModule.update({
      code:'',
      retCode: -1,
      message: '',
      reduction: 0,
      typeReduction: '',
      productId: this.item.product.id,
      quantity: 0,
    });
  }

  private increment() {
    cartModule.add({
      code:'',
      retCode: -1,
      message: '',
      reduction: 0,
      typeReduction: '',
      productId: this.item.product.id,
      quantity: 1,
    });
  }

  private decrement() {
    cartModule.add({
      code:'',
      retCode: -1,
      message: '',
      reduction: 0,
      typeReduction: '',
      productId: this.item.product.id,
      quantity: -1,
    });
  }

  private setQuantity(e: InputEvent) {
    const value = (e.target as HTMLInputElement).valueAsNumber;
    if (!Number.isNaN(value)) {
      cartModule.update({
        code:'',
        retCode: -1,
        message: '',
        reduction: 0,
        typeReduction: '',
        productId: this.item.product.id,
        quantity: value,
      });
    }
  }
}

